import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { BehaviorSubject, combineLatest, map } from 'rxjs';
import { NotificationService } from './notification.service';

@Component({
  selector: 'lib-notifications',
  standalone: true,
  imports: [AsyncPipe, MatButtonModule],
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[attr.data-position]': 'position' },
})
export class NotificationsComponent {
  readonly notifications = inject(NotificationService);
  @Input() position: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left' =
    'top-right';
  private readonly selectedKey = new BehaviorSubject<string | undefined>(
    undefined,
  );
  @Input() set key(value: string | undefined) {
    this.selectedKey.next(value);
  }
  readonly messages$ = combineLatest([
    this.notifications.messages$,
    this.selectedKey,
  ]).pipe(
    map(([messages, key]) => messages.filter((message) => message.key === key)),
  );
}
